import InputMask from "react-input-mask"
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";

interface IMaskInput {
    defaultValue?: string;
    mask: string;
    id: string;
    label: string;
    handle?: (value: string) => void;
    value?: string;
}


export const MaskInput = (prop: IMaskInput) => {
    const [value, setValue] = useState(prop.value ? prop.value : '')
    useEffect(()=>{
        if(prop.handle) {
            prop.handle(value)
        }
        if(prop.value) {
            setValue(prop.value)
       }
    }, [prop.value])
    const handleChange = (e: any) => {
        setValue(e.target.value)
        if (prop.handle) {
            prop.handle(e.target.value)
        }
    }
    const formaBirthday = () => {
        if (prop.defaultValue) {
        const list = prop.defaultValue.split('-')
        const newDate = `${list[2]}${list[1]}${list[0]}`
        return newDate
        }
        }
    
    const defaultValue = prop.id === 'birthday' ? formaBirthday() : prop.defaultValue
    return(
        
        <InputMask
        defaultValue={defaultValue}
            mask={prop.mask}
            onChange={(e) => handleChange(e)}
            value={value}
        >
        {           
        //@ts-ignore
       
         () => (<TextField 
                sx={{width: "100%"}}
                id={prop.id}
                label={prop.label} 
                variant="outlined"
                color="secondary"
                size='small'
             />)
        }
        </InputMask>
    )
}